import React, {Component} from 'react';
import CommonUtils from '../utils/CommonUtils';
import iconAvatar from '../medias/logo.jpg';
import '../styles/HeaderView.css';

class HeaderView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            data: {}
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(JSON.stringify(nextProps.data) !== JSON.stringify(prevState.data)) {
            return {
                data: nextProps.data
            }
        }
        return null
    }
    
    render() {
        const { data } = this.state
        const { handleContinuing } = this.props

        return (
            <div className="view-header">
                <div className="container-left">
                    <div className="fl wrapper-avatar">
                        <img src={data.avatar?data.avatar:iconAvatar} alt=""/>
                    </div>
                    <div className="fl wrapper-basic">
                        <div className="name word-ellipsis">{CommonUtils.isEmpty(data.nickName)?'会员':data.nickName}</div>
                        <div className="brand word-ellipsis">{data.description?data.description:'PS SWITCH XBOX'}</div>
                    </div>
                </div>
                {data.gameMinutes?(
                    <div className={`container-right${CommonUtils.isEmpty(data.deviceId)?' hide':''}`}>
                        <button className="btn-continuing" disabled={!data.enableContinuing} onClick={handleContinuing}>{data.continuingText?data.continuingText:'继续游戏'}</button>
                    </div>
                ):<div className='container-right'></div>}
            </div>
        )
    }
}

export default HeaderView;


// WEBPACK FOOTER //
// ./src/components/HeaderView.js